<ul class="options" [ngClass]="{'ttt': isSearch }">
  <li class="item not-mobile" *ngIf="!isSearch">
    <a class="action" id="open-calendar" (click)="openMenu()"> 
      <img src="../../../assets/svgs/{{ showColumnCalendar ? 'close-bar' : 'open-menu-bar' }}.svg" alt="Calendario">
    </a>
  </li>
  <li class="item not-mobile" *ngIf="!isSearch">
    <a class="action" id="search" (click)="openFilterClick()">
      <img src="../../../assets/svgs/search_icon.svg" alt="Busca">
      <img class="img-dot" src="../../../assets/svgs/dot-alert.svg" alt="Busca" *ngIf="isAlert">
    </a>
  </li>
  <li class="item-close" *ngIf="isSearch">
    <a class="action" id="close-table" (click)="clearFilter.emit()"> 
      <img src="../../../assets/svgs/close_calendar.svg" alt="Busca">
      <span class="description">Sair</span>
    </a>
  </li>
  <li class="not-mobile" *ngIf="!isSearch">
    <app-button-option [options]="options" (clickAction)="selectItem($event)"></app-button-option>
  </li>
  <li class="not-mobile" *ngIf="!isSearch">
    <a class="action-now" id="now" (click)="goToday()">
      <img src="../../../assets/svgs/now.svg" alt="Hoje">
      <p class="description">Hoje</p>
    </a>
  </li>
  <li class="item not-mobile"  *ngIf="!isSearch">
    <a class="action" id="gear" (click)="clickGear.emit(isGear = !isGear)">
      <img src="../../../assets/svgs/gear.svg" alt="Engrenagem">
    </a>
  </li>
  <li class="item no-border" *ngIf="!isSearch">
    <a class="action" id="arrow-left" (click)="decrement()">
      <img src="../../../assets/svgs/arrow_left.svg" alt="Voltar">
    </a>
  </li>
  <li class="item no-border mrgl-40" *ngIf="!isSearch">
    <a class="action" id="arrow-right" (click)="increment()">
      <img src="../../../assets/svgs/arrow_right_ico.svg" alt="Próximo">
    </a>
  </li>
  <li *ngIf="!isSearch">
    <p *ngIf="month && year">{{ month }} de {{ year }}</p>
  </li>
  <div class="hell">
    <li class="mobile-action">
      <a class="action" id="open-menu-bar" (click)="closeModal()">
        <img src="../../../assets/svgs/open-menu-bar.svg" alt="Abrir">
      </a>
    </li>
    <li class="mobile-action">
      <a class="action" id="plus">
        <img src="../../../assets/svgs/plus.svg" alt="Eventos">
      </a>
    </li>
  </div>
</ul>



<div class="menu-mobile" [ngClass]="{'active': open}">
  <div class="menu-bar">
    <div class="scrollbar-thumb">
      <div class="actions-bar">
        <ul class="list">
          <li class="items" *ngFor="let item of optionsList; let i = index">
            <a class="action" id="{{item}}-{{i}}" (click)="selectItem(item)" [ngClass]="{'select': item === calendarViewMode}">{{ item }}</a>
          </li>
        </ul>
        <ul class="close-now">
          <li class="items">
            <a class="action" id="now-sidebar" (click)="closeModal(); openFilterClick()">
              <img src="../../../assets/svgs/search_icon.svg" alt="Hoje">
            </a>
          </li>
          <li class="items">
            <a class="action" id="now-sidebar" (click)="goToday()">
              <img src="../../../assets/svgs/now.svg" alt="Hoje">
            </a>
          </li>
          <li class="items">
            <a class="action" id="close-bar" (click)="closeModal()">
              <img src="../../../assets/svgs/close-bar.svg" alt="Fechar">
            </a>
          </li>
        </ul>
      </div>
      <ul class="checkboxs">
        <li class="check-item">
          <lib-input-checkbox id="birthday" name="birthday" label="Aniversário dos clientes"></lib-input-checkbox>
        </li>
        <li class="check-item">
          <lib-input-checkbox id="holiday-br" name="holiday-br" label="Feriados do Brasil"></lib-input-checkbox>
        </li>
      </ul>
      <div class="list-facs">
        <ng-content></ng-content>
      </div>
    </div>
  </div>
  <div class="overlay" id="close-overlay" (click)="closeModal()"></div>
</div>